{
	"useDropperPrompt": "Use the Point Color Dropper to add samples."
}
